/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementModification
 */
export interface ServiceAgreementModification {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    modificationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    payload?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    productAttributeId?: string;
    /**
     * creator
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    createdBy?: string;
    /**
     * last modifier
     * @type {string}
     * @memberof ServiceAgreementModification
     */
    modifiedBy?: string;
    /**
     * creation date
     * @type {Date}
     * @memberof ServiceAgreementModification
     */
    createdAt?: Date;
    /**
     * last modification date
     * @type {Date}
     * @memberof ServiceAgreementModification
     */
    modifiedAt?: Date;
}

/**
 * Check if a given object implements the ServiceAgreementModification interface.
 */
export function instanceOfServiceAgreementModification(value: object): value is ServiceAgreementModification {
    return true;
}

export function ServiceAgreementModificationFromJSON(json: any): ServiceAgreementModification {
    return ServiceAgreementModificationFromJSONTyped(json, false);
}

export function ServiceAgreementModificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementModification {
    if (json == null) {
        return json;
    }
    return {
        
        'modificationId': json['modificationId'] == null ? undefined : json['modificationId'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'status': json['status'] == null ? undefined : json['status'],
        'productAttributeId': json['productAttributeId'] == null ? undefined : json['productAttributeId'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': json['modifiedAt'] == null ? undefined : (new Date(json['modifiedAt'])),
    };
}

export function ServiceAgreementModificationToJSON(json: any): ServiceAgreementModification {
    return ServiceAgreementModificationToJSONTyped(json, false);
}

export function ServiceAgreementModificationToJSONTyped(value?: ServiceAgreementModification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modificationId': value['modificationId'],
        'payload': value['payload'],
        'status': value['status'],
        'productAttributeId': value['productAttributeId'],
        'createdBy': value['createdBy'],
        'modifiedBy': value['modifiedBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'modifiedAt': value['modifiedAt'] == null ? value['modifiedAt'] : value['modifiedAt'].toISOString(),
    };
}

